function load_cart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;

      try {
        var fgSetAttribute = function (value) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { fg_dismissed: value } }),
          }).catch(function () {});
        };

        document.querySelectorAll('.snippet-cart-free-gift[data-fg-clear-dismiss]').forEach(function () {
          fgSetAttribute('');
        });

        document.querySelectorAll('.snippet-cart-free-gift[data-fg-auto-dismiss]').forEach(function (banner) {
          var hide = function () {
            banner.classList.add('is-dismissed');
            fgSetAttribute('true');
            // Wait for the opacity/max-height transition to finish before display:none,
            // with a fallback timeout in case transitionend doesn't fire for any reason.
            var finish = function () {
              banner.classList.add('is-hidden');
            };
            banner.addEventListener('transitionend', finish, { once: true });
            setTimeout(finish, 500);
          };
          var timer = setTimeout(hide, 4000);
          var closeBtn = banner.querySelector('.snippet-cart-free-gift__close');
          if (closeBtn) {
            closeBtn.addEventListener('click', function () {
              clearTimeout(timer);
              hide();
            });
          }
        });
      } catch (e) {
        if (window.console && console.warn) console.warn('[free-gift-banner]', e);
      }

      document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener('click', (evt) => removeItem(data_line));
      });
      document.querySelectorAll('.quantity-minus').forEach(function (minus) {
        var data_line = minus.dataset.line;
        minus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) - 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });
      document.querySelectorAll('.quantity-plus').forEach(function (plus) {
        var data_line = plus.dataset.line;
        plus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) + 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });


      document.querySelectorAll('.promo-btm .grid-color a:not(.quick_view_button)').forEach(function (colors) {

        colors.addEventListener('click', function (e) {

          e.preventDefault();
          e.stopImmediatePropagation();

          let parentPromo = colors.closest('.cp-promo-inr');

          // Image change
          parentPromo.querySelector('.promo-media img')
            .setAttribute('srcset', colors.getAttribute('data-img'));

          let active_id = colors.getAttribute('data-id');

          // Remove active color only inside current promo
          parentPromo.querySelectorAll('.grid-color a:not(.quick_view_button)')
            .forEach(el => el.classList.remove('active-color'));

          colors.classList.add('active-color');

          // Remove active variant only inside current promo
          parentPromo.querySelectorAll('.grid-variant-outer ul')
            .forEach(el => el.classList.remove('active-variant-wrap'));

          // Loop with break support
          let variants = parentPromo.querySelectorAll('.grid-variant-outer ul');

          for (let variant of variants) {
            let ids = variant.getAttribute('data-id');

            if (active_id == ids) {
              variant.classList.add('active-variant-wrap');
              break; // loop stop thai jase ✅
            }
          }

        });

      });
      // document.querySelectorAll('.promo-btm .grid-color a').forEach(function (colors) {
      //   colors.addEventListener('click', function (e) {
      //     e.preventDefault();
      //     e.stopImmediatePropagation();
      //     colors.closest('.cp-promo-inr').querySelector('.promo-media img').setAttribute('srcset',colors.getAttribute('data-img'));
      //     let id = colors.getAttribute('data-id');
      //     document.querySelectorAll('.promo-btm .grid-color a').forEach(function (rm_colors) {
      //       rm_colors.classList.remove('active-color');
      //     });
      //     colors.classList.add('active-color');
      //     document.querySelectorAll('.promo-variant .grid-variant-outer').forEach(function (variant) {
      //       let ids = variant.getAttribute('data-id');
      //       let active_id = document.querySelector('.promo-btm .grid-color a.active-color').getAttribute('data-id');
      //       console.log(active_id,'active_id',ids);
      //       if(active_id == ids){
      //         console.log('match');
      //         document.querySelectorAll('.promo-variant .grid-variant-outer').forEach(function (rm_variant){
      //           rm_variant.classList.remove('active-variant-wrap');
      //         });
      //         variant.classList.add('active-variant-wrap');
      //         return false;
      //       }
      //     });
      //   });
      // });
      document.querySelectorAll('.header-cart').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
        });
      });
      document.querySelectorAll('.overlay-box, .cart-drawer-close').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          const body = document.querySelector('body');
          if (cartButton.classList.contains('overlay-box') && body.classList.contains('open-quick-buy') && body.classList.contains('open-drawer')) {
            // Overlay clicked while quick buy is open inside cart drawer — only close quick buy
            body.classList.remove('open-quick-buy');
          } else {
            body.classList.remove('open-drawer', 'open-quick-buy', 'open-menu', 'open-search', 'open-sort', 'open-filter', 'open-account-popup');
          }
        });
      });

      let items = document.querySelectorAll('.item-row');
      let promos = document.querySelectorAll('.cp-promo-inr');

      let cartProductIds = [];
      items.forEach(item => {
        cartProductIds.push(item.getAttribute('data-product-id'));
      });

      // Activate eligible promo cards (max 3) and mark added ones; account for color swatches
      // Pre-collect all promo-ids so we can exclude swatches that belong to a different card's bundle
      let allPromoIds = Array.from(promos).map(p => p.getAttribute('promo-id'));

      // Track which promo product IDs have already triggered promo-added on another card,
      // so a shared swatch product in cart can only cause promo-added on one card.
      let claimedAddedIds = [];
      let eligibleCount = 0;
      promos.forEach(function(promo) {
        let mainId = promo.getAttribute('main-id');
        let promoId = promo.getAttribute('promo-id');
        // Start with this card's own promo product, then add swatch IDs that are NOT
        // the promo-id of a different card (prevents cross-bundle false positives)
        let promoProductIds = [promoId];
        promo.querySelectorAll('.grid-color a[data-id]').forEach(function(swatch) {
          let sid = swatch.getAttribute('data-id');
          if (sid && !promoProductIds.includes(sid) && !(allPromoIds.includes(sid) && sid !== promoId)) {
            promoProductIds.push(sid);
          }
        });
        let mainInCart = cartProductIds.includes(mainId);
        // Only consider IDs not already claimed by a previously processed card
        let unclaimedIds = promoProductIds.filter(id => !claimedAddedIds.includes(id));
        let anyPromoInCart = unclaimedIds.some(id => cartProductIds.includes(id));
        if (mainInCart && anyPromoInCart) {
          promo.classList.add('promo-added');
          // Claim all matched IDs so no other card can also show promo-added for them
          unclaimedIds.filter(id => cartProductIds.includes(id)).forEach(id => claimedAddedIds.push(id));
        } else if (mainInCart && !anyPromoInCart && eligibleCount < 3) {
          promo.classList.add('active');
          eligibleCount++;
        }
      });
      empty_cart();
      productRecommended();
      accordian();
      if (typeof window.$th_refreshWishlistItems === 'function') 
          window.$th_refreshWishlistItems();

      updateExpectedDate();
      
      if (typeof bindQuickViewButtons === 'function') {
        bindQuickViewButtons();
      }
      if (typeof quickAddButton === 'function') {
        quickAddButton();
      }
      if (typeof quickproductrow === 'function') {
        quickproductrow();
      }

    });

}
load_cart();
function removeItem(data_line) {
  const data = { line: data_line, quantity: 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        load_cart();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function updateItem(data_line, quantity) {
  const data = { line: data_line, quantity: quantity };
  let error_grid = document.querySelector(`#Quantity-${data_line}`).closest('.item-row').querySelector('.grid-error');
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        if(data.status == 422)
          {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                    error_grid.innerHTML = '';
                    load_cart();

              },2000);
        }else{
          load_cart();
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}



async function productRecommended() {
  const firstItem = document.querySelector('.item-row');
  if (!firstItem) return;

  const productId = firstItem.getAttribute('data-product-id');
  const container = document.getElementById('complementary-products-container');
  if (!container) return;

  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  // wrapper.innerHTML = '<li class="swiper-slide loading">Loading Recommendations...</li>';
  const SECTION_ID = 'product-recommended-grid';

  try {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&recommendation_method=complementary&limit=4`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    const handles = (data.products || []).map(p => p.handle).filter(Boolean);

    if (handles.length === 0) {
      wrapper.innerHTML = '<li class="swiper-slide">No recommendations found.</li>';
      return;
    }

    const sections = await Promise.all(
      handles.map(async handle => {
        try {
          const r = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
          const json = await r.json();
          return json[SECTION_ID];
        } catch (err) {
          console.error(`Failed to load ${handle}:`, err);
          return `<div class="error">Failed to load ${handle}</div>`;
        }
      })
    );

    wrapper.innerHTML = sections
      .map(sectionHTML => `<li class="swiper-slide">${sectionHTML}</li>`)
      .join('');

    productrow();
    quickproductrow();
    quickAddButton();
    bindQuickViewButtons();
    // $th_refreshWishlistItems();
    // updateFLCprice();
    

    if (window.cartRecommendedSwiper) {
      window.cartRecommendedSwiper.destroy(true, true);
      window.cartRecommendedSwiper = null;
    }

    if (window.Swiper) {
      window.cartRecommendedSwiper = new Swiper('.cart-recommended-slider', {
        slidesPerView: 'auto',
        spaceBetween: 1,
        slidesOffsetAfter: 12,
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'progressbar',
        // },
        scrollbar: {
          el: ".cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
        grabCursor: true,
        on: {
          scrollbarDragStart() {
            document.body.classList.add('dragging');
          },
          scrollbarDragEnd() {
            document.body.classList.remove('dragging');
          }
        },
        breakpoints: {
          991:{ slidesOffsetAfter: 24 },
        },
      });

    }

  } catch (error) {
    console.error('Error fetching recommendations:', error);
    wrapper.innerHTML = '<li class="swiper-slide error">Error loading recommended products.</li>';
  }
}

function empty_cart(){
  window.cartRecommendedSwiper = new Swiper('.empty_cart-recommended-slider', {
    slidesPerView: 'auto',
    spaceBetween: 1,

    scrollbar: {
          el: ".empty_cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
    grabCursor: true,
    on: {
      scrollbarDragStart() {
        document.body.classList.add('dragging');
      },
      scrollbarDragEnd() {
        document.body.classList.remove('dragging');
      }
    },
    slidesOffsetAfter: 12,
    breakpoints: {
      992: {
        slidesOffsetAfter: 24,
      },
    },
  });
  quickAddButton();
  quickproductrow();
  bindQuickViewButtons();
  // productrow();
  // updateFLCprice();
}



function updateExpectedDate() {
  if (typeof window.__flaneurUpdateExpectedDate === 'function') {
    window.__flaneurUpdateExpectedDate();
    return;
  }

  function extractDeliveryDate(raw) {
    var text = (raw || '').trim();
    if (!text) return '';
    var parts = text.split(':');
    return parts[parts.length - 1].trim();
  }

  function walkNestscaleComponents(comp, visit, depth) {
    if (!comp || depth > 8) return;
    visit(comp);
    var subTree = comp.subTree;
    if (!subTree) return;
    if (subTree.component) walkNestscaleComponents(subTree.component, visit, depth + 1);
    if (Array.isArray(subTree.children)) {
      subTree.children.forEach(function (child) {
        if (child && child.component) walkNestscaleComponents(child.component, visit, depth + 1);
      });
    }
  }

  function getNestscaleDeliveredMaximumDate() {
    var root = document.querySelector('.ns-edd-product-page');
    if (!root || !root._vnode || !root._vnode.component) return '';
    var maxDate = '';
    walkNestscaleComponents(root._vnode.component, function (comp) {
      if (maxDate) return;
      var proxy = comp.proxy || comp.setupState;
      if (proxy && proxy.orderDeliveredMaximumDate) {
        maxDate = String(proxy.orderDeliveredMaximumDate).trim();
      }
    }, 0);
    return maxDate;
  }

  var dateText = getNestscaleDeliveredMaximumDate();

  if (!dateText) {
    var edDiv = document.querySelector('.drawer-middle .ed-div');
    if (edDiv) dateText = extractDeliveryDate(edDiv.textContent);
  }

  if (!dateText) {
    var editorParagraph =
      document.querySelector('.ns-edd-product-page .ql-editor p') ||
      document.querySelector('.ql-editor p');
    if (editorParagraph) {
      dateText = extractDeliveryDate(editorParagraph.textContent);
    }
  }

  if (!dateText) {
    var outOfStockMessage = document.querySelector('#oos-message-widget');
    if (outOfStockMessage) {
      dateText = extractDeliveryDate(outOfStockMessage.textContent);
    }
  }

  if (!dateText) return;

  document.querySelectorAll('.expected-date').forEach(function (target) {
    target.textContent = dateText;
    target.style.filter = 'blur(0)';
    target.classList.add('remove-blur');
  });
}
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateExpectedDate, 1000);
  setTimeout(updateExpectedDate, 2500);
});

document.addEventListener("DOMContentLoaded", function() {
  function initApplePayButtonCheck() {
    const applePayButton = document.querySelector(".cart-apple-pay-btn");
    if (!applePayButton) {
      setTimeout(initApplePayButtonCheck, 500);
      return;
    }
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
    if (!(isIOS && isSafari)) {
      applePayButton.style.display = "none";
    }
  }
  initApplePayButtonCheck();
});







    